module.exports = __webpack_public_path__ + "static/media/el_camino_college_logo.f8788432.jpg";